// Notice: this enum must match the server enum
export enum StorageObjectPermissionLevel {
  None = 0,
  Unchanged = 1, // don't change permission
  View = 2,   // view, download
  Edit = 4,   // rename, delete, move
  Append = 8  // add files to folder
}

// tslint:disable-next-line:no-namespace
export namespace StorageObjectPermissionLevel {
  export function toString(storageObjectPermissionLevel: StorageObjectPermissionLevel): string {
    switch (storageObjectPermissionLevel) {
      case StorageObjectPermissionLevel.None:
        return 'None';
      case StorageObjectPermissionLevel.Unchanged:
        return 'Unchanged';
      case StorageObjectPermissionLevel.View:
        return 'View';
      case StorageObjectPermissionLevel.Edit:
        return 'Edit';
      case StorageObjectPermissionLevel.Append:
        return 'Append';
      default:
        return 'None';
    }
  }

  export function parse(storageObjectPermissionLevelStr: string): StorageObjectPermissionLevel {
    return StorageObjectPermissionLevel[storageObjectPermissionLevelStr];
  }
}

export default StorageObjectPermissionLevel;
